import { config, executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getUrl } from './config'
import { isSuccessResponse } from '../utils'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
  // return data
}

const accessConfig = () => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.authAccessConfig),
    method: 'GET',
    config: config.default,
    cache: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { accessConfig }
